import axios from 'axios';

console.log('INIT BASE URL:', process.env.REACT_APP_API_SERVER); // ✅ log untuk pastikan benar

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER, // ✅ WAJIB pakai prefix ini
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;